/**
 * 教室信息与邀请：房间号、密码、进入链接，一键复制。
 * 对应腾讯会议的「会议信息 / 邀请」。
 */

import { useState } from 'react'

import { useRoomStore } from '../stores/roomStore'

/** 复制到剪贴板。没有 clipboard API（非安全上下文）时退回到选区复制。 */
export async function copyText(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text)
      return true
    }
  } catch {
    // 落到下面的兜底
  }
  const ta = document.createElement('textarea')
  ta.value = text
  ta.style.position = 'fixed'
  ta.style.opacity = '0'
  document.body.appendChild(ta)
  ta.select()
  let ok = false
  try { ok = document.execCommand('copy') } catch { ok = false }
  ta.remove()
  return ok
}

/** 拼出发给别人的邀请文本。 */
export function inviteText(name: string, id: number, password: string, link: string): string {
  const lines = [`${name || '网梯课堂'} 邀请你进入教室`, `房间号：${id}`]
  if (password) lines.push(`密码：${password}`)
  lines.push(`进入链接：${link}`)
  return lines.join('\n')
}

export function RoomInfo({ roomPassword, onClose }: { roomPassword: string; onClose: () => void }) {
  const room = useRoomStore((s) => s.room)
  const count = useRoomStore((s) => s.members.size)
  const [done, setDone] = useState<'' | 'all' | 'link' | 'fail'>('')
  if (!room) return null
  const link = `${location.origin}${location.pathname}?room=${room.id}`
  const copy = async (what: 'all' | 'link') => {
    const ok = await copyText(what === 'all' ? inviteText(room.name, room.id, roomPassword, link) : link)
    setDone(ok ? what : 'fail')
  }
  return (
    <div className="dlg-mask" onClick={onClose}>
      <div className="dlg narrow room-info" onClick={(e) => e.stopPropagation()} role="dialog" aria-label="教室信息">
        <h3>{room.name || '教室'}</h3>
        <dl className="ri-list">
          <dt>房间号</dt><dd className="ri-id">{room.id}</dd>
          <dt>密码</dt><dd>{roomPassword ? roomPassword : <span className="ri-none">未设置</span>}</dd>
          <dt>进入链接</dt><dd className="ri-link">{link}</dd>
          <dt>在场人数</dt><dd>{count} / {room.maxUsers || '不限'}</dd>
          {room.notice && <><dt>公告</dt><dd className="ri-notice">{room.notice}</dd></>}
        </dl>
        <div className="dlg-foot">
          <span className="ri-done">
            {done === 'all' && '邀请信息已复制'}
            {done === 'link' && '链接已复制'}
            {done === 'fail' && '复制失败，请手动选择复制'}
          </span>
          <button onClick={() => copy('link')}>复制链接</button>
          <button className="primary" onClick={() => copy('all')}>复制邀请信息</button>
          <button onClick={onClose}>关闭</button>
        </div>
      </div>
    </div>
  )
}
